import { render, staticRenderFns } from "./BlockType25.vue?vue&type=template&id=711e85c5&scoped=true&"
import script from "./BlockType25.vue?vue&type=script&lang=ts&"
export * from "./BlockType25.vue?vue&type=script&lang=ts&"
import style0 from "./BlockType25.vue?vue&type=style&index=0&id=711e85c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711e85c5",
  null
  
)

export default component.exports